import React from "react"
import { useSelector } from "react-redux"

import PropTypes from "prop-types"

import { selectGenericState } from "@/store/features/genericSlice"

import { SWATCH_NA, EMPTY_PIXEL } from "@/constants/index"
import swatchMissing from "@/public/images/swatch-missing.jpeg"

const ColorSwatch = props => {
  const {
    type = "",
    id = "",
    label = "",
    name = "",
    value = "",
    checked = false,
    color = "",
    colorUrl = "",
    initConfig,
  } = props || {}

  const { globalConfig } = useSelector(selectGenericState)

  const { general: { scene7AccountName = "PAWEB" } = {} } =
    initConfig || globalConfig

  const swatchUrlName = colorUrl
    ? colorUrl + "?$PDPSwatch_Desk$"
    : swatchMissing

  const swatchUrl = swatchUrlName.replace("PAWEB", scene7AccountName)

  return (
    <div className="color-swatch" title={label}>
      <input
        type={type === "selector" ? "radio" : "checkbox"}
        id={id}
        name={name}
        value={value}
        checked={checked}
        style={{ backgroundColor: color }}
        onClick={e => !checked && props.onClick(e.target.value)}
        onChange={e => props.onChange(e)}
        data-testid={`color-swatch-${id ?? "0"}`}
      />
      {type !== "selector" && <label htmlFor={id}>{label}</label>}
      {type === "selector" && (
        <label
          className={`${
            !colorUrl || colorUrl.includes(SWATCH_NA) ? "--no-swatch" : ""
          }`}
          htmlFor={id}
        >
          {swatchUrl ? (
            <img role="presentation" src={swatchUrl} alt="NA" />
          ) : (
            <img role="presentation" src={EMPTY_PIXEL} alt="EMPTY_PIXEL" />
          )}
        </label>
      )}
    </div>
  )
}

ColorSwatch.defaultProps = {
  type: "",
  label: "",
  id: "",
  name: "",
  value: undefined,
  color: "",
  colorUrl: "",
  checked: undefined,
  defaultChecked: false,
  onClick: () => {},
  onChange: () => {},
}

ColorSwatch.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string || PropTypes.number,
  color: PropTypes.string,
  colorUrl: PropTypes.string,
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  onMouseEnter: PropTypes.func,
}

export default ColorSwatch
